import React from 'react';
import styled from 'styled-components';
import * as Ink from '@carta/ink';

const ButtonWrapper = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1010;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
`;

interface FeedbackButtonProps {
  url: string;
}

export const FeedbackButton: React.FC<FeedbackButtonProps> = ({ url }) => {
  return (
    <ButtonWrapper>
      <Ink.Button href={url} target="_blank" rel="noopener noreferrer" aria-label="Provide feedback" type="default">
        Feedback
      </Ink.Button>
    </ButtonWrapper>
  );
};

export default FeedbackButton;
